import type { IGetContactRequest } from 'services/pod/types';

export interface IPhoneLookupAttribution {
  contactExternalId: string | null;
  companyExternalId: string | null;
}

export const attributionFromPhoneLookup = (
  contact: Partial<IGetContactRequest> | null | undefined,
): IPhoneLookupAttribution => {
  if (!contact || contact.isAmbiguous) {
    return { contactExternalId: null, companyExternalId: null };
  }
  return {
    contactExternalId: contact.userId ? String(contact.userId) : null,
    companyExternalId: contact.companyId ? String(contact.companyId) : null,
  };
};
